import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";

import { HotelSearch, useHomePageHotelSearch } from "@tenant/hotels";
import { Icon } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./HomePageHotelSearch.module.scss";

export type HomePageHotelSearchComponentProps = PlatformComponentProps;
export const HomePageHotelSearch = ({
  children,
  className,
}: HomePageHotelSearchComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HomePageHotelSearch;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { handlers, text } = useHomePageHotelSearch();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("search")}>
        <HotelSearch />
      </div>
      <div className={cn("search-entry")}>
        <button
          onClick={() => handlers.handleMobileRedirect()}
          className={cn("start-search-button")}
        >
          <Icon iconName={IconNameEnum.search} className={cn("button-icon")} />
          {text.mobileButtonLabel}
        </button>
      </div>
      {children}
    </div>
  );
};
